module.exports = __webpack_public_path__ + "static/the-new-geography-of-jobs-7a40e132a2252d92fd80b88a5f5a42ea.jpg";